import Vue from "vue";
import VueRouter from "vue-router";

import Main from "@/views/Main";

import TileManagement from "@/views/TileManagement";
import AddTile from "@/views/AddTile";
import EditTile from "@/views/EditTile";

import Settings from "@/views/Settings";

import Login from "@/views/Login";
import Register from "@/views/Register";
import Activate from "@/views/Activate";

Vue.use(VueRouter);

var router = new VueRouter({
    routes: [
        {
            path: "*",
            redirect: "/"
        },
        {
            path: "/",
            name: "Main",
            component: Main
        },
        {
            path: "/management",
            name: "TileManagement",
            component: TileManagement
        },
        {
            path: "/add_tile",
            name: "AddTile",
            component: AddTile
        },
        {
            path: "/edit_tile/:id",
            name: "EditTile",
            component: EditTile
        },
        {
            path: "/login",
            name: "Login",
            component: Login
        },
        {
            path: "/register",
            name: "Register",
            component: Register
        },
        {
            path: "/settings",
            name: "Settings",
            component: Settings
        },
        {
            path: "/activate",
            name: "Activate",
            component: Activate
        }
    ]
});

export default router;